import Cropper from "cropperjs"

export default class ImageCropper {
  #initialized = false
  #cropper = null
  #cropFromField = null
  #cropSizeField = null

  constructor(image, settings) {
    this.image = image
    this.defaultBox = settings.default_box
    this.aspectRatio = settings.ratio
    this.#cropFromField = document.getElementById(
      settings.crop_from_form_field_id
    )
    this.#cropSizeField = document.getElementById(
      settings.crop_size_form_field_id
    )
    this.elementId = settings.element_id
    this.elementEditor = document.querySelector(
      `[data-element-id='${this.elementId}']`
    )
    this.dialog = Alchemy.currentDialog()
    if (this.dialog) {
      this.dialog.options.closed = () => this.destroy()
      this.bind()
    }
    this.init()
  }

  get cropperOptions() {
    return {
      aspectRatio: this.aspectRatio,
      viewMode: 1,
      zoomable: false,
      checkCrossOrigin: false, // Prevent CORS issues
      checkOrientation: false, // Prevent loading the image via AJAX which can cause CORS issues
      data: this.box
    }
  }

  get cropFrom() {
    if (this.#cropFromField?.value) {
      return this.#cropFromField.value.split("x").map((v) => parseInt(v))
    }
  }

  get cropSize() {
    if (this.#cropSizeField?.value) {
      return this.#cropSizeField.value.split("x").map((v) => parseInt(v))
    }
  }

  get box() {
    if (this.cropFrom && this.cropSize) {
      return {
        x: this.cropFrom[0],
        y: this.cropFrom[1],
        width: this.cropSize[0],
        height: this.cropSize[1]
      }
    } else {
      return this.defaultBoxSize
    }
  }

  get defaultBoxSize() {
    return {
      x: this.defaultBox[0],
      y: this.defaultBox[1],
      width: this.defaultBox[2],
      height: this.defaultBox[3]
    }
  }

  init() {
    if (!this.#initialized) {
      this.#cropper = new Cropper(this.image, this.cropperOptions)
      this.#initialized = true
    }
  }

  update(coords) {
    this.#cropFromField.value = `${coords.x}x${coords.y}`
    this.#cropFromField.dispatchEvent(new Event("change"))
    this.#cropSizeField.value = `${coords.width}x${coords.height}`
    this.#cropSizeField.dispatchEvent(new Event("change"))
  }

  reset() {
    const cropper = this.#cropper
    // Apply the default size. cropperjs clamps the crop box to its maximum size.
    cropper.setData(this.defaultBoxSize)
    // When the default box sits at the maximum crop box size, sub-pixel rounding
    // makes cropperjs treat setData's box as oversized and revert its position
    // (renderCropBox resets top/left to their old values). Re-apply the position
    // in canvas coordinates afterwards – that does not touch the size, so it is
    // not reverted and the mask actually moves to the default box.
    const canvas = cropper.getCanvasData()
    const scale = canvas.width / canvas.naturalWidth
    cropper.setCropBoxData({
      left: canvas.left + this.defaultBoxSize.x * scale,
      top: canvas.top + this.defaultBoxSize.y * scale
    })
    this.update(this.defaultBoxSize)
  }

  destroy() {
    if (this.#cropper) {
      this.#cropper.destroy()
    }
    this.#initialized = false
    return true
  }

  bind() {
    this.dialog.dialog_body.find('button[type="submit"]').on("click", () => {
      const data = this.#cropper.getData(true)
      this.update(data)
      this.elementEditor.setDirty()
      this.dialog.close()
      return false
    })
    this.dialog.dialog_body.find('button[type="reset"]').on("click", () => {
      this.reset()
      return false
    })
  }
}
